import React from 'react';
import './shared.css';

const LiveTechSupport: React.FC = () => {
  return (
    <div className="page-container">
      <div className="content-card">
        <h1>Live Tech Support</h1>
        
        <div className="alert alert-info">
          <strong>Premium Service:</strong> Live Tech Support is available exclusively to Premium Members.
        </div>

        <p>
          Get real-time technical support from our experienced automotive technicians. 
          Our live support team is available to help you with diagnostic procedures, 
          repair techniques, and technical questions.
        </p>

        <div>
          <h3>How It Works</h3>
          <ol>
            <li>Contact us during business hours (8 AM - 6 PM CST)</li>
            <li>Provide your membership information</li>
            <li>Describe your technical issue or question</li>
            <li>Get immediate assistance from our experts</li>
          </ol>
        </div>

        <div>
          <h3>Contact Information</h3>
          <p>
            <strong>Phone:</strong> 800-660-7156<br />
            <strong>Hours:</strong> Monday - Friday, 8:00 AM - 6:00 PM CST<br />
            <strong>Email:</strong> support@aeuromotive.com
          </p>
        </div>

        <div>
          <h3>Not a Premium Member?</h3>
          <p>
            Upgrade to Premium Membership to access live tech support and other exclusive features.
          </p>
          <a href="/membership" className="btn btn-large">
            Upgrade to Premium
          </a>
        </div>

        <div>
          <h3>Alternative Support Options</h3>
          <ul>
            <li>
              <strong>Technical Forum:</strong>{' '}
              <a href="http://forum.aeuromotive.com/" target="_blank" rel="noopener noreferrer">
                forum.aeuromotive.com
              </a>
            </li>
            <li>
              <strong>Video Training:</strong>{' '}
              <a href="/video-training">Access our training library</a>
            </li>
            <li>
              <strong>System Manuals:</strong>{' '}
              <a href="/system-manuals">Technical documentation</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LiveTechSupport;

